/* @flow */

import {
    getPedido,
    getCliente,
    getEndereco,
    getTaxaEntrega,
    getFormaPagamentoSelecionada,
} from './pedido';
import { getItens, getValorItens } from './itens';
import { type Pedido } from '../../pedidos/types';
import { type FinalizacaoState } from './types';
import { type State, type GetState } from '../../preact-app/types';
import { ETAPA_EXECUCAO } from '../../pedidos/constants';
import imprimirPorPedidosId from '../../atendimento/imprimir-por-pedidos-id';
import { isImpressaoAutomatica } from '../empresa';

export type SetPedidoFinalizadoAction = {
    type: 'balcao/finalizacao/SET_PEDIDO_FINALIZADO',
    pedido: Pedido,
};

export type FinalizacaoAction =
    | SetPedidoFinalizadoAction;

// Action Types

export const SET_PEDIDO_FINALIZADO = 'balcao/finalizacao/SET_PEDIDO_FINALIZADO';

// Action Creators

export const setPedidoFinalizado = (pedido: Pedido): SetPedidoFinalizadoAction => ({
    type: SET_PEDIDO_FINALIZADO,
    pedido,
});

// Selectors

export const getFinalizacao = (state: State) => state.balcao.finalizacao;

// Thunk

const imprimir = () => (dispatch: Function, getState: GetState) => {
    const finalizacao = getFinalizacao(getState());
    if (finalizacao) {
        imprimirPorPedidosId(finalizacao.id);
    }
};

const impressaoAutomatica = () => (dispatch: Function, getState: GetState) => {
    if (isImpressaoAutomatica(getState())) {
        dispatch(imprimir());
    }
};

export const setPedidoFinalizadoThunk = () => (dispatch: Function, getState: GetState) => {
    const state = getState();
    const pedido = getPedido(state);
    const storage = JSON.parse(localStorage.getItem('preact-app-state'));
    const unidadeSelecionada = storage.empresa.unidadesSelecionadas[0];

    dispatch(setPedidoFinalizado({
        id: pedido.id || 0,
        entrada: '',
        entrega: null,
        valor: getValorItens(state),
        troco: pedido.troco,
        voucher: pedido.voucher,
        cpfNota: pedido.cpfNota,
        valorVoucher: pedido.valorVoucher,
        endereco: getEndereco(state),
        taxaEntrega: getTaxaEntrega(state),
        formaPagamento: getFormaPagamentoSelecionada(state),
        usuario: getCliente(state),
        entregador: null,
        produtosUrl: '',
        etapasUrl: '',
        etapasId: ETAPA_EXECUCAO,
        comissao: null,
        origem: 'balcao',
        etapa: {
            etapasId: ETAPA_EXECUCAO,
            entrada: '',
            nome: '',
            observacao: '',
        },
        produtos: getItens(state),
        valorMoeda: null,
        distancia: null,
        melhorEntregador: null,
        nomeUnidade: '',
        politicaFrete: 0,
        unidadesNegocioId: unidadeSelecionada,
    }));
    dispatch(impressaoAutomatica());
};


const initialState = null;

const finalizacaoReducer = (
    state: FinalizacaoState = initialState,
    action: FinalizacaoAction,
): FinalizacaoState => {
    switch (action.type) {
    case SET_PEDIDO_FINALIZADO:
        return action.pedido;
    default:
        return state;
    }
};

export default finalizacaoReducer;
